import React, { useEffect, useState } from "react";
// import { useStoreState } from "easy-peasy";
import {
  Loader,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "@transfr-inc/dashboard-components";
import { Button } from "@transfr-inc/dashboard-components/forms";

import "./delete-category.modal.scss";

export function DeleteCategoryModal({
  onCancel,
  open,
  onDeleteCategory,
  category,
}) {
  const [loading, setLoading] = useState();
  const { categoryName } = category;

  const deleteCategory = async () => {
    setLoading(true);
    try {
      onDeleteCategory();
    } finally {
      setLoading();
      onCancel();
    }
  };

  return (
    <Modal
      open={open}
      modalClassName={"delete-modal"}
      onClose={onCancel}
      preventClose={loading}
    >
      {loading && <Loader overlay></Loader>}
      <ModalHeader
        className="red-icon"
        icon={["fa-solid", "fa-clock-rotate-left"]}
        title="Delete Category"
      ></ModalHeader>
      <ModalBody>
        <>
          Are you sure you would like to delete the category{" "}
          <strong>{categoryName}</strong>?
        </>
      </ModalBody>
      <ModalFooter>
        <Button onClick={onCancel}>Cancel</Button>
        <Button className="red-icon" destructive onClick={deleteCategory}>
          Yes, Delete
        </Button>
      </ModalFooter>
    </Modal>
  );
}
